export default __webpack_public_path__ + "static/media/logo_Codewin.f83dcc61.svg";